import React from 'react';
import { Card } from 'flowbite-react';

/**
 * CardBox component - Unified card component with MatDash styling
 * Combines Flowbite Card with custom MatDash theme
 */
const CardBox = ({
  children,
  className = '',
  title = '',
  subtitle = '',
  headerAction = null,
  padding = true,
  shadow = 'md',
  hover = false,
  onClick = null,
  ...props
}) => {
  const shadowClasses = {
    none: 'shadow-none',
    sm: 'shadow-matdash-sm',
    md: 'shadow-matdash-base',
    lg: 'shadow-matdash-lg',
    xl: 'shadow-matdash-xl',
  };

  const baseClasses = `
    bg-white dark:bg-gray-800
    rounded-matdash-md
    ${shadowClasses[shadow] || shadowClasses.md}
    ${hover ? 'hover:shadow-matdash-lg transition-shadow duration-200' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    ${className}
  `;

  const innerClasses = padding ? 'p-6' : '';

  // If using title/subtitle or headerAction, render with header
  if (title || headerAction) {
    return (
      <div className={baseClasses} onClick={onClick} {...props}>
        <div className="p-6 pb-4 border-b border-gray-100 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div>
              {title && (
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {subtitle}
                </p>
              )}
            </div>
            {headerAction && (
              <div className="ml-4">
                {headerAction}
              </div>
            )}
          </div>
        </div>
        <div className={innerClasses}>
          {children}
        </div>
      </div>
    );
  }

  // Simple card without header
  return (
    <div className={baseClasses} onClick={onClick} {...props}>
      <div className={innerClasses}>
        {children}
      </div>
    </div>
  );
};

// Export variants for quick access
export const CardBoxFlat = (props) => <CardBox shadow="none" {...props} />;
export const CardBoxHover = (props) => <CardBox hover={true} {...props} />;
export const CardBoxClickable = (props) => <CardBox hover={true} onClick={props.onClick} {...props} />;

export default CardBox;